import services from '@/http'
import * as storage from '../storage'
import * as types from './mutation-types'

export const ActionFindClassList = ({
  dispatch
}, payload) => {
  return services.units.findClassList({
    id: payload.id
  }).then(res => {
    dispatch('ActionSetClassList', res.data)
  })
}

export const ActionUpdateClass = (context, payload) => (
  services.showClass.updateClass(payload)
)

export const ActionFindClassSchedulesList = ({
  dispatch
}, payload) => {
  return services.units.findClassSchedulesList(
    payload
  ).then(res => {
    dispatch('ActionSetClassSchedulesList', res.data)
  })
}

export const ActionFindSchedulesList = ({
  dispatch,

}, payload) => {

  return services.units.findSchedulesList({
    idClassSchedule: payload.id
  }).then(res => {
    dispatch('ActionSetSchedulesList', res.data)
  })
}

export const ActionSetSchedulesList = ({
  commit
}, payload) => {

  commit(types.SET_SCHEDULES_LIST, payload)
}

export const ActionSetCurrentUnit = ({
  commit
}, payload) => {
  storage.setLocalCurrentUnit(payload)
  commit(types.SET_CURRENT_UNIT, payload)
}

export const ActionGetCurrentUnit = ({
  commit
}) => {

  let unit = storage.getLocalCurrentUnit()
  if (unit !== null) {
    commit(types.SET_CURRENT_UNIT, unit)
  }
}

export const ActionSetClassList = ({
  commit
}, payload) => {
  commit(types.SET_CLASS_LIST, payload)
}

export const ActionSetClassSchedulesList = ({
  commit
}, payload) => {
  commit(types.SET_CLASS_SCHEDULES_SCHEDULE_LIST, payload)
}

export const ActionDeleteCurrentUnit = () => {
  storage.deleteLocalCurrentUnit();
}

export const ActionDoSchedule = (context, payload) => (
  services.units.doSchedule(payload)
)
export const ActionRemoveSchedule = (context, payload) => (
  services.units.removeSchedule(payload)
)
export const ActionUpdateUnit = (context, payload) => (
  services.units.updateUnit(payload)
)